"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));

var classnames_1 = __importDefault(require("classnames"));

require("./SzTable.scss");

exports.sortCaret = function (order, column) {
  switch (order) {
    case 'asc':
      return react_1.default.createElement("span", {
        className: "sz-normal-font-size ml-2 mdi mdi-chevron-down"
      });

    case 'desc':
      return react_1.default.createElement("span", {
        className: "sz-normal-font-size ml-2 mdi mdi-chevron-up"
      });

    default:
      return react_1.default.createElement("span", {
        className: "sz-normal-font-size ml-2 mdi mdi-unfold-more-horizontal"
      });
  }
};

function SzTable(_a) {
  var data = _a.data,
      columns = _a.columns,
      className = _a.className,
      defaultSorted = _a.defaultSorted,
      keyField = _a.keyField,
      rowEvents = _a.rowEvents,
      rowClasses = _a.rowClasses;
  var tableClasses = classnames_1.default('sz-table bg-white', className);
  return react_1.default.createElement(react_bootstrap_table_next_1.default, {
    bootstrap4: true,
    rowClasses: rowClasses,
    keyField: keyField,
    rowEvents: rowEvents,
    data: data,
    columns: columns,
    defaultSorted: defaultSorted,
    headerClasses: "sz-table-header border-0 bg-light-blue",
    classes: tableClasses,
    wrapperClasses: "w-100",
    bordered: false
  });
}

exports.default = SzTable;
SzTable.propTypes = {
  data: prop_types_1.default.array.isRequired,
  columns: prop_types_1.default.arrayOf(prop_types_1.default.shape({
    dataField: prop_types_1.default.string,
    text: prop_types_1.default.string,
    classes: prop_types_1.default.string,
    headerClasses: prop_types_1.default.string,
    sort: prop_types_1.default.bool,
    formatter: prop_types_1.default.func
  })).isRequired,
  className: prop_types_1.default.string,
  defaultSorted: prop_types_1.default.arrayOf(prop_types_1.default.shape({
    dataField: prop_types_1.default.string,
    order: prop_types_1.default.string
  })),
  keyField: prop_types_1.default.string.isRequired,
  rowEvents: prop_types_1.default.shape({
    onClick: prop_types_1.default.func
  }),
  rowClasses: prop_types_1.default.func
};